import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Login from "features/Login";
import AddPartner from "features/AddPartner"
import Users from "features/Users"
import News from "features/News"

import * as routes from "routes";
import CustomRoute from "routes/customRoute";
import AddNews from "features/AddNews";
import Podcast from "features/Podcast"
import AddPodcast from "features/AddPodcast"
import VerifyNews from "features/VerifyNews";
import VerifyPodcast from "features/VerifyPodcast";
import Statistics from "features/Statistics";
import VerifiedUser from "features/VerifiedUser";
import UnverifiedUser from "features/UnverifiedUser";
import PendingUser from "features/PendingUser";


const App = () => {
  const authenticated = localStorage.getItem("token");


  return (
    <Router>
      <Switch>
        <Route
          render={(props) =>
            authenticated ? <Redirect to="/" /> : <Login {...props} />
          }
          path={routes.LOGIN}
          exact
        />
         <CustomRoute
          restricted
          path={routes.ADD_PARTNER}
          exact
          component={AddPartner}
        />
         <CustomRoute
          restricted
          path={routes.USERS}
          exact
          component={Users}
        />
          <CustomRoute
          restricted
          path={routes.NEWS}
          exact
          component={News}
        />
         <CustomRoute
          restricted
          path={routes.ADD_NEWS}
          exact
          component={AddNews}
        />
        <CustomRoute
          restricted
          path={routes.ADD_PODCAST}
          exact
          component={Podcast}
        />\
        <CustomRoute
          restricted
          path={routes.CREATE_PODCAST}
          exact
          component={AddPodcast}
        />
         <CustomRoute
          restricted
          path={routes.VERIFY_NEWS}
          exact
          component={VerifyNews}
        />
        <CustomRoute
          restricted
          path={routes.VERIFY_PODCAST}
          exact
          component={VerifyPodcast}
        />
        <CustomRoute
          restricted
          path={routes.STATISTICS}
          exact
          component={Statistics}
        />
        <CustomRoute
          restricted
          path={routes.VERIFIED_USER}
          exact
          component={VerifiedUser}
        />
        <CustomRoute
          restricted
          path={routes.UNVERIFIED_USER}
          exact
          component={UnverifiedUser}
        />
        <CustomRoute
          restricted
          path={routes.PENDING_USER}
          exact
          component={PendingUser}
        />
      </Switch>
    </Router>
  );
};

export default App;
